export enum WeightUnitsEnum {
  KG = 'kg',
  G = 'g',
}
